import LangSelector from './LangSelector'

export default LangSelector
